import React from 'react';
import { Radio, RadioGroup, FormControlLabel, FormControl, TextField, Checkbox, Grid, Chip } from '@mui/material';
import styles from '../../Steppers/AlertStepper.module.scss';
import { ALERT_DETAILS } from '../../../../containers/Alerts/constants.alerts';
import { fetchLandmarkList } from '../../../../containers/Maintenance/helper-classes/common-services';
import AsyncSelectWrapper from '../../../SharedComponents/AsyncSelectWrapper';
import dropdownNested from '../../../../assets/icons/arrow-down.svg';
import stylesAsset from '../../../SharedComponents/AssetCriteria/AssetCriteriaStyles';

type Props = {
    formData: {
        config: {
            stopDays: Number,
            stopHours: Number,
            stopMinutes: Number,
            selectedLandmarkGroups: any,
            selectedLandmarkFilters: any,
        },
    },
    handleTextboxChange: Function,
    handleCheckboxChange: Function,
    clearLandmarkSelects: Function,
    allLandmarkGroups: any,
};

type State = {
    allLandmarkGroups: any,
    landmarks: any,
    alertForLandmark: string,
};

class StopAlert extends React.Component<Props, State> {
    constructor(props) {
        super(props);
        const landmarks = props.landmarks || {};

        landmarks.groups = props.formData.config.selectedLandmarkGroups || landmarks.groups;
        landmarks.landmarks = props.formData.config.selectedLandmarkFilters || landmarks.landmarks;
        let alertForLandmark = '';
        if (props.formData.config.insideSelectedLandmark) {
            alertForLandmark = 'insideSelectedLandmark';
        } else if (props.formData.config.outsideSelectedLandmark) {
            alertForLandmark = 'outsideSelectedLandmark';
        }
        this.state = {
            landmarks,
            allLandmarkGroups: [],
            alertForLandmark,
        };
    }

    UNSAFE_componentWillReceiveProps(nextprops) {
        const { allLandmarkGroups, formData } = nextprops;
        const { stateAllLandmarkGroups } = this.state;
        if (allLandmarkGroups && allLandmarkGroups.length > 0 &&
            stateAllLandmarkGroups !== allLandmarkGroups) {
            this.setState({
                allLandmarkGroups,
            });
        }

        if (formData.config.insideSelectedLandmark || formData.config.outsideSelectedLandmark) {
            this.setState({
                alertForLandmark: formData.config.insideSelectedLandmark ? 'insideSelectedLandmark' : 'outsideSelectedLandmark',
            });
        }
    }

    labelForType = type => (type === 'groups' ? 'name' : 'landmarks')

    loadOptions = (type, inputValue) =>
        new Promise((resolve) => {
            const loadCriteria = this.props.allLandmarkGroups;
            let optionData = loadCriteria.map(datum => ({
                value: datum.id,
                label: datum.name,
                data: datum,
            }));
            if (inputValue) {
                optionData = optionData.filter(option => (
                    option.label.toLowerCase().includes(inputValue.toLowerCase())
                ));
            }
            resolve(optionData);
        });

    onItemSelected = (type, selected) => {
        const { landmarks } = this.state;
        if (type === 'groups') {
            if (landmarks.landmarks.length >= 1 && landmarks[type].length === 0) {
                landmarks.landmarks=[];
                this.props.clearLandmarkSelects(landmarks.landmarks);
            }
        }
        if (landmarks[type].filter(item => item.id === selected.data.id).length === 0) {
            landmarks[type].push(selected.data);
            this.setState({ landmarks }, () => {
                this.props.handleTextboxChange(type)({
                    target: {
                        value: landmarks[type],
                    },
                });
            });
        }
    }

    handleDelete = (type, data) => {
        const { landmarks } = this.state;
        const landmarksGroups = landmarks[type];
        const chipToDelete = landmarksGroups.indexOf(data);
        landmarksGroups.splice(chipToDelete, 1);
        landmarks[type] = landmarksGroups;
        if (type === 'groups') {
            const deleteLandmarkList = landmarks.landmarks.filter(item =>
                item.parentGroupId !== data.id);
            landmarks.landmarks = deleteLandmarkList;
            this.setState({
                ...this.state,
                landmarks,
            }, () => {
                this.props.handleTextboxChange(type)({
                    target: {
                        value: landmarks[type],
                    },
                });
                this.props.clearLandmarkSelects(deleteLandmarkList);
            });
        } else {
            this.setState({
                ...this.state,
                landmarks,
            }, () => {
                this.props.handleTextboxChange(type)({
                    target: {
                        value: landmarks[type],
                    },
                });
            });
        }
    }

    loadNext = loadedOptions => new Promise((resolve, reject) => {
        fetchLandmarkList(loadedOptions.length, this.props.formData.config.selectedLandmarkGroups)
            .then((response) => {
                const { landmarkList, data } = response;
                if (data && data.total) {
                    const hasMore = (loadedOptions.length + data.data.length) < data.total;
                    if (data) {
                        const optionData = landmarkList.map(datum => ({
                            value: datum.id,
                            label: datum.name,
                            data: datum,
                        }));
                        resolve({ options: optionData, hasMore });
                    } else reject();
                } else reject();
            });
    });

    showAlertForLandmark = (e) => {
        const { landmarks } = this.state;
        const { checked } = e.target;

        if (!checked) {
            landmarks.groups = [];
            landmarks.landmarks = [];
        }
        this.setState({
            alertForLandmark: checked ? 'insideSelectedLandmark' : '',
            landmarks,
        }, () => {
            if (checked) {
                this.props.handleCheckboxChange('insideSelectedLandmark')(e);
            } else {
                this.props.handleCheckboxChange('outsideSelectedLandmark')(e);
                this.props.handleCheckboxChange('insideSelectedLandmark')(e);
                this.props.handleTextboxChange('selectedLandmarkGroups')({
                    target: {
                        value: landmarks.groups,
                    },
                });
                this.props.handleTextboxChange('selectedLandmarkFilters')({
                    target: {
                        value: landmarks.landmarks,
                    },
                });
            }
        });
    }

    getLandmarkGroupSection = (disableChips) => {
        let landmarkGroupSection = null;
        if (this.state.allLandmarkGroups !== undefined && this.state.allLandmarkGroups.length > 0) {
            const type = 'groups';

            landmarkGroupSection = (
                <div>
                    <Grid container spacing={5}>
                        <Grid item xs={10}>
                            <FormControl className={styles['landmark-selection']}>
                                <AsyncSelectWrapper
                                    key={`${type}_${disableChips}`}
                                    handleDelete={item => this.handleDelete(type, item.id)}
                                    loadOptions={inputValue => this.loadOptions(type, inputValue)}
                                    onItemSelected={selected => this.onItemSelected(type, selected)}
                                    title="All Groups"
                                    disableChips={disableChips}
                                    disablePaging
                                    styles={disableChips ? { container: stylesAsset.selectInternalContainer } : { select: { width: '20%' } }}
                                    selectStyles={{
                                        control: () => ({
                                            display: 'flex',
                                            border: 'none',
                                            boxShadow: 'none !important',
                                        }),
                                        option: (s, { data }) => {
                                            const obj = data.data || {};
                                            if (obj.nestLevel) {
                                                return {
                                                    ...s,
                                                    marginLeft: 8 + (obj.nestLevel * 12),
                                                    paddingLeft: obj.nestLevel ? 24 : s.paddingLeft,
                                                    backgroundImage: `url(${dropdownNested})`,
                                                    backgroundRepeat: 'no-repeat',
                                                    backgroundPosition: 'left center',
                                                };
                                            }
                                            return s;
                                        },
                                    }}
                                    menuPlacement="bottom"
                                />
                            </FormControl>
                        </Grid>
                    </Grid>
                </div>
            );
        }

        return landmarkGroupSection;
    }

    getLandmarkSelection = (disableChips) => {
        let landmarksSection = null;
        const type = 'landmarks';
        const landmarkList = this.state.allLandmarkGroups;
        const lmgIds = this.props.formData.config.groups ?
            this.props.formData.config.groups.map(lmg => lmg.id) :
            this.props.formData.config.groups;

        if (this.props.formData.config.landmarks) {
            for (let i = 0; i < this.state.landmarks.landmarks.length; i+=1) {
                for (let j = 0; j < this.props.formData.config.landmarks.length; j+=1) {
                    if (this.state.landmarks.landmarks[i].value ===
                        this.props.formData.config.landmarks[j].id) {
                        this.state.landmarks.landmarks[i] = this.props.formData.config.landmarks[j];
                    }
                }
            }
        }

        landmarksSection = (
            <div style={{ width: '100%' }}>
                <Grid container spacing={5}>
                    <Grid item xs={10}>
                        <FormControl className={styles['landmark-selection']}>
                            <AsyncSelectWrapper
                                key={`${type}_${disableChips}_${lmgIds}`}
                                handleDelete={item => this.handleDelete(type, item.id)}
                                selectedOptions={landmarkList.map(item => ({
                                    value: item.id,
                                    label: item.name,
                                    data: item,
                                }))}
                                loadOptions={(inputValue, loadedOptions) =>
                                    this.loadNext(loadedOptions)}
                                onItemSelected={selected => this.onItemSelected(type, selected)}
                                title="All Landmarks"
                                disableChips={disableChips}
                                styles={disableChips ? { container: stylesAsset.selectInternalContainer } : { select: { width: '20%' } }}
                                selectStyles={{
                                    control: () => ({
                                        display: 'flex',
                                        border: 'none',
                                        boxShadow: 'none !important',
                                    }),
                                    option: (s, { data }) => {
                                        const obj = data.data || {};
                                        if (obj.nestLevel) {
                                            return {
                                                ...s,
                                                marginLeft: 8 + (obj.nestLevel * 12),
                                                paddingLeft: obj.nestLevel ? 24 : s.paddingLeft,
                                                backgroundImage: `url(${dropdownNested})`,
                                                backgroundRepeat: 'no-repeat',
                                                backgroundPosition: 'left center',
                                            };
                                        }
                                        return s;
                                    },
                                }}
                                menuPlacement="bottom"
                            />
                        </FormControl>
                    </Grid>
                </Grid>
            </div>
        );

        return landmarksSection;
    }

    updateAlertForLandmark = (e) => {
        this.setState({ alertForLandmark: e.target.value });
        if (e.target.value === 'insideSelectedLandmark') {
            this.props.handleCheckboxChange('insideSelectedLandmark')({ target: { checked: true } });
            this.props.handleCheckboxChange('outsideSelectedLandmark')({ target: { checked: false } });
        } else {
            this.props.handleCheckboxChange('insideSelectedLandmark')({ target: { checked: false } });
            this.props.handleCheckboxChange('outsideSelectedLandmark')({ target: { checked: true } });
        }
    }

    render() {
        const disableChips = true;
        const { alertForLandmark } = this.state;

        return (
            <div className={styles['.step-content']}>
                <div className={styles['vertical-divider']}>
                    <div className={styles['step-rightside']} style={{ paddingTop: 0 }}>
                        <form noValidate autoComplete="off">
                            <div>
                                <div>{ALERT_DETAILS.LABEL.STOP_EVENT}*</div>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <div>
                                        <TextField
                                            required
                                            margin="normal"
                                            className={styles['text-mid-wid']}
                                            id="stopDays"
                                            name="stopDays"
                                            type="number"
                                            InputProps={{
                                                inputProps: {
                                                    min: ALERT_DETAILS.VALUE.STD_MIN,
                                                    max: ALERT_DETAILS.VALUE.STD_MAX,
                                                },
                                            }}
                                            value={this.props.formData.config.stopDays}
                                            onChange={this.props.handleTextboxChange('stopDays')}
                                        />
                                        <div className={styles['unit-mid-name']}>{ALERT_DETAILS.LABEL.STOP_DAYS}</div>
                                    </div>
                                    <div>
                                        <TextField
                                            required
                                            margin="normal"
                                            className={styles['text-mid-wid']}
                                            id="stopHours"
                                            name="stopHours"
                                            type="number"
                                            InputProps={{
                                                inputProps: {
                                                    min: ALERT_DETAILS.VALUE.STH_MIN,
                                                    max: ALERT_DETAILS.VALUE.STH_MAX,
                                                },
                                            }}
                                            value={this.props.formData.config.stopHours}
                                            onChange={this.props.handleTextboxChange('stopHours')}
                                        />
                                        <div className={styles['unit-mid-name']}>{ALERT_DETAILS.LABEL.STOP_HOURS}</div>
                                    </div>
                                    <div>
                                        <TextField
                                            required
                                            margin="normal"
                                            className={styles['text-mid-wid']}
                                            id="stopMinutes"
                                            name="stopMinutes"
                                            type="number"
                                            InputProps={{
                                                inputProps: {
                                                    min: ALERT_DETAILS.VALUE.STM_MIN,
                                                    max: ALERT_DETAILS.VALUE.STM_MAX,
                                                },
                                            }}
                                            value={this.props.formData.config.stopMinutes}
                                            onChange={this.props.handleTextboxChange('stopMinutes')}
                                        />
                                        <div className={styles['unit-mid-name']}>{ALERT_DETAILS.LABEL.STOP_MINUTES}</div>
                                    </div>
                                </div>
                                <div style={{ paddingTop: 20, display: 'flex', alignItems: 'center' }}>
                                    <div>
                                        <Checkbox
                                            color="primary"
                                            sx={{ paddingLeft: 0 }}
                                            disableRipple
                                            checked={this.state.alertForLandmark}
                                            onChange={this.showAlertForLandmark}
                                        />
                                    </div>
                                    <div style={{ paddingLeft: 10 }}>
                                        Filter by inside/outside landmarks
                                    </div>
                                </div>
                                {this.state.alertForLandmark &&
                                    <>
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            <FormControl>
                                                <RadioGroup
                                                    aria-labelledby="demo-controlled-radio-buttons-group"
                                                    name="controlled-radio-buttons-group"
                                                    value={alertForLandmark}
                                                    onChange={(e) => this.updateAlertForLandmark(e)}
                                                >
                                                    <FormControlLabel
                                                        value="insideSelectedLandmark"
                                                        control={
                                                            <Radio
                                                                disableRipple
                                                                disableFocusRipple
                                                            />
                                                        }
                                                        label="Alert only inside landmark(s)"
                                                    />
                                                    <FormControlLabel
                                                        value="outsideSelectedLandmark"
                                                        control={
                                                            <Radio
                                                                disableRipple
                                                                disableFocusRipple
                                                            />
                                                        }
                                                        label="Alert only outside landmark(s)"
                                                    />
                                                </RadioGroup>
                                            </FormControl>
                                        </div>
                                        <div style={{ paddingTop: 20 }}>
                                            <div>{ALERT_DETAILS.LABEL.LANDMARK_GROUP}</div>
                                            {this.getLandmarkGroupSection(disableChips)}
                                        </div>
                                        <div>
                                            {
                                                this.state.landmarks.groups.map(data => (
                                                    <Chip
                                                        id={data.id}
                                                        className={styles['chip-spacing']}
                                                        key={data.id}
                                                        label={data.name}
                                                        onDelete={() => this.handleDelete('groups', data)}
                                                    />
                                                ))
                                            }
                                        </div>
                                        <div className={styles['div-pad']}>
                                            <div>{ALERT_DETAILS.LABEL.LANDMARK}</div>
                                            {this.getLandmarkSelection(disableChips)}
                                        </div>
                                        <div>
                                            {
                                                this.state.landmarks.landmarks.map(data => (
                                                    <Chip
                                                        id={data.id}
                                                        className={styles['chip-spacing']}
                                                        key={data.id ? data.id : data.value}
                                                        label={data.name}
                                                        onDelete={() => this.handleDelete('landmarks', data)}
                                                    />
                                                ))
                                            }
                                        </div>
                                    </>
                                }
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        );
    }
}

export default StopAlert;
